import { ESearchFilterValue } from '@cbgms/components/src/top-search/topSearchUtils'

export const usePlaceholderText = (searchFilter: ESearchFilterValue) => {
  switch (searchFilter) {
    case ESearchFilterValue.AllGMS:
      return 'global.search_placeholder'
    case ESearchFilterValue.AllPortal:
      return 'global.search_placeholder_portal_b2b'
    case ESearchFilterValue.Account:
      return 'global.search_placeholder_account'
    case ESearchFilterValue.Invoice:
      return 'global.search_placeholder_invoice'
    case ESearchFilterValue.Order:
      return 'global.search_placeholder_order'
    case ESearchFilterValue.Parts:
      return 'global.search_placeholder_parts'
    case ESearchFilterValue.Quotations:
      return 'global.search_placeholder_quotations'
    case ESearchFilterValue.WorkOrder:
      return 'global.search_placeholder_workorder'
    case ESearchFilterValue.Vehicles:
      return 'global.search_placeholder_vehicle'
    case ESearchFilterValue.Tyres:
      return 'global.search_placeholder_tyres'
    default:
      return 'global.search'
  }
}
